import userEditView from './userEditComponent.html';
import './userEditComponent.css';
import _ from 'lodash';
import { ensure } from 'components/sharpr/ensure/ensure';

export function userEditComponent() {
	return {
		bindings: {
			user: '<',
			access: '<',
			showDefaultHub: '<',
			homePageSetting: '<',
		},
		controllerAs: 'vm',
		controller: userEditComponentCtrl,
		template: userEditView,
	};
}

export class userEditComponentCtrl {
	constructor(Api, Cfg, Identity, modal, notifications) {
		'ngInject';
		this.Api = Api;
		this.Cfg = Cfg;
		this.Identity = Identity;
		this.modal = modal;
		this.notifications = notifications;
		this.setupDefaultHomePage();
	}
	setupDefaultHomePage() {
		if (this.homePageSetting && this.homePageSetting.allowed_values) {
			this.homePageOptions = this.homePageSetting.allowed_values.map(allowedValue => {
				return {
					id: allowedValue.value,
					name: allowedValue.text,
				};
			});
		} else {
			this.homePageOptions = [];
		}
	}

	$onInit() {
		this.isPostApprovalEnabled = this.Cfg.read('Features.post_approval') === '1';
		this.defaultHomePage = this.Cfg.read('Features.home_page');
		this.canEditDefaultHub = !this.user.sso || !String(this.user.sso.diff_strategy).includes('defaultHub');
	}

	$onChanges(changes) {
		this.record = _.clone(this.user);
		this.allowedHubs = [];
		const accounts = ensure.array(this.access.accounts);
		const showAccountName = this.Identity.isSuperadmin() || accounts.length > 1;
		accounts.forEach(account => {
			account.hubs.forEach(hub => {
				if (hub.role != 'observer') {
					const hubObj = {
						id: hub.id,
						$search: `${account.name} › ${hub.name} @${hub.id}`,
						$label: showAccountName ? `${account.name} › ${hub.name}` : hub.name,
					};
					this.allowedHubs.push(hubObj);
					if (hub.id == this.record.default_hub_id) {
						this.default_hub_object = hubObj;
					}
				}
			});
		});
	}

	async save() {
		if (!this.isValidEmail()) {
			this.modal.alert({ text: 'Please provide a valid email address.' });
			return;
		}
		if (!this.isValidName()) {
			this.modal.alert({ text: 'Please provide a first and last name.' });
			return;
		}
		let userId;
		if (this.Identity.user().id == this.user.id) {
			// update loggedin user
			userId = 'me';
			this.Identity.setUser(this.record);
		} else {
			userId = this.user.id;
		}
		this.isSaving = true;
		if (this.homePageSetting) {
			await this.saveDefaultPage();
		}
		this.record.default_hub_id = this.default_hub_object.id;
		this.Api.patchDifference(`/users/${userId}`, this.user, this.record).then(resp => {
			this.user = _.clone(this.record);
			this.isSaving = false;
			if (resp && resp.status == 409) {
				const myHubIds = this.Identity.allowedClientIds().join(',');
				this.Api.get('/users/search', { email: this.record.email }, { Hubs: myHubIds }).then(users => {
					let msg;
					if (users && users.length && users[0].is_superadmin == false) {
						msg = `That email address belongs to another user. Please use another email address or <a href="?#/admin/users/${users[0].id}/edit">edit the other user</a>.`;
					} else {
						msg =
							'That email address belongs to another user. Please use another email address or contact your account manager for assistance.';
					}
					this.record.email = this.user.email;
					this.modal.alert({ escapedHtml: msg });
				});
			}
			this.notifications.showSuccess({ message: 'Changes saved.' });
		});
	}
	saveDefaultPage() {
		return this.Cfg.write('Features.home_page', this.defaultHomePage, 'user');
	}

	isValidEmail() {
		return /^[^@]+@[^@]+\.[^@]+$/.test(this.record.email);
	}

	isValidName() {
		return this.record.fname && this.record.lname;
	}
}
